import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function useCountUp(target, duration = 1400) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting && !started.current && target > 0) {
          started.current = true;
          const start = performance.now();
          const step = (now) => {
            const p = Math.min(1, (now - start) / duration);
            setValue(Math.floor(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) requestAnimationFrame(step);
            else setValue(target);
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, [target, duration]);

  return [ref, value];
}

function StatCard({ label, target }) {
  const [ref, value] = useCountUp(target || 0);
  return (
    <div ref={ref} className="card-soft rounded-2xl p-8">
      <div className="text-sm font-medium" style={{ color: 'var(--text-muted)' }}>{label}</div>
      <div className="mt-3 text-4xl lg:text-5xl font-semibold tracking-tight">
        {value.toLocaleString('tr-TR')}
      </div>
    </div>
  );
}

export default function Stats() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => axios.get(`${API}/stats`).then(r => setData(r.data)).catch(() => {});
    load();
    const i = setInterval(load, 60000);
    return () => clearInterval(i);
  }, []);

  return (
    <section id="stats" className="py-20 lg:py-28 relative">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <span className="text-xs font-semibold uppercase tracking-widest" style={{ color: 'var(--text-muted)' }}>İstatistik</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-semibold tracking-tight">İstatistikler</h2>
          <p className="mt-3 max-w-lg" style={{ color: 'var(--text-muted)' }}>Türk Ordusu Simulasyonu V2 oyunumuzun anlık oynanma verisi Roblox API'den canlı olarak alınmaktadır.</p>
        </div>

        <div className="mt-12 flex justify-center w-full">
          <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-3 gap-8">
            <StatCard label="Gruptaki Kişi Sayısı" target={data?.groupMembers || 0} />
            <StatCard label="Anlık Oyuncu Sayısı" target={data?.playersOnline || 0} />
            <StatCard label="Site Ziyareti" target={data?.siteVisits || 0} />
          </div>
        </div>
      </div>
    </section>
  );
}
